import React from 'react';
import styled from 'styled-components';

type Props = {
  label: string;
  checked: boolean;
  onToggle: () => void;
};

const SubmissionChip: React.FC<Props> = ({ label, checked, onToggle }) => (
  <Chip type="button" $checked={checked} onClick={onToggle} aria-pressed={checked}>
    <Indicator $checked={checked} aria-hidden>
      {checked && (
        <svg width="10" height="10" viewBox="0 0 10 10">
          <path
            d="M2 5.2 L4.2 7.4 L8 3.2"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
    </Indicator>
    <span>{label}</span>
  </Chip>
);

export default SubmissionChip;

const Chip = styled.button<{ $checked: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 32px;
  padding: 0 12px;
  border-radius: 999px;
  border: 1px solid ${({ $checked }) => ($checked ? 'var(--primary-600)' : 'var(--border)')};
  background: ${({ $checked }) => ($checked ? 'var(--primary-50)' : 'var(--neutral-0)')};
  color: ${({ $checked }) => ($checked ? 'var(--primary-700)' : 'var(--neutral-700)')};
  font-family: inherit;
  font-size: 0.8125rem;
  font-weight: 600;
  letter-spacing: 0.01em;
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease;

  &:hover {
    border-color: var(--primary-600);
    color: var(--primary-700);
  }

  &:focus-visible {
    outline: none;
    box-shadow: var(--shadow-focus);
  }
`;

const Indicator = styled.span<{ $checked: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 4px;
  border: 1px solid ${({ $checked }) => ($checked ? 'var(--primary-600)' : 'var(--neutral-400)')};
  background: ${({ $checked }) => ($checked ? 'var(--primary-600)' : 'var(--neutral-0)')};
  color: var(--neutral-0);
`;
